<template>
  <RouterView />
</template>

<script setup>
import { watch, watchEffect } from 'vue'
import { useAuth, useUser } from '@clerk/vue'
import { setAuthTokenGetter } from '@/lib/axios'
import { identifyUser, resetUser } from '@/lib/posthog'

const { getToken } = useAuth()
const { user, isLoaded } = useUser()

// Set up axios to use Clerk's token
// getToken from useAuth() is a Vue ref, so we wrap it to call .value()
watchEffect(() => {
  setAuthTokenGetter(() => getToken.value())
})

// Tie PostHog identity to the Clerk session. Wait for isLoaded so the initial
// null doesn't fire a spurious reset before Clerk hydrates.
watch(
  [isLoaded, user],
  ([loaded, u]) => {
    if (!loaded) return
    if (u) identifyUser(u)
    else resetUser()
  },
  { immediate: true }
)
</script>
